import { render } from "./StoreJoin.vue?vue&type=template&id=497a4e5a&scoped=true"
import script from "./StoreJoin.vue?vue&type=script&lang=js"
export * from "./StoreJoin.vue?vue&type=script&lang=js"

import "./StoreJoin.vue?vue&type=style&index=0&id=497a4e5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497a4e5a"]])

export default __exports__